import * as React from "react";

/**
 * Calls `onIdle` after `timeoutMs` of no user activity. Used to auto-lock the
 * terminal back to the shift screen when an operator walks away. Any pointer,
 * key, or touch event resets the timer.
 */
export function useIdleLock(timeoutMs: number, onIdle: () => void, enabled: boolean): void {
  const onIdleRef = React.useRef(onIdle);
  onIdleRef.current = onIdle;

  React.useEffect(() => {
    if (!enabled) return;
    let timer = window.setTimeout(() => onIdleRef.current(), timeoutMs);
    const reset = () => {
      window.clearTimeout(timer);
      timer = window.setTimeout(() => onIdleRef.current(), timeoutMs);
    };
    const events = ["pointerdown", "keydown", "mousemove", "touchstart", "wheel"];
    for (const e of events) window.addEventListener(e, reset, { passive: true });
    return () => {
      window.clearTimeout(timer);
      for (const e of events) window.removeEventListener(e, reset);
    };
  }, [timeoutMs, enabled]);
}
